import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';

@Injectable({
  providedIn: 'root',
})
export class TelemetryServices {
  constructor(
    protected http: HttpClient,
    @Inject(TelemetryService) private _telemetryService: TelemetryService,
  ) {}

  telemetryImpression(impressionData) {
    this._telemetryService.impression(impressionData, {
      context: {
        authtoken: localStorage.getItem('access-token'),
      },
    });
  }

  telemetryInteract(interactData) {
    this._telemetryService.interact(interactData, {
      context: {
        authtoken: localStorage.getItem('access-token'),
      },
    });
  }

  telemetryEnd(_Enddata) {
    // this._telemetryService.end(Enddata, {
    //   context: {
    //     authtoken: localStorage.getItem("access-token")
    //   }
    // });
  }
}
